const doc = [({"loading":"text-20 gray-400 align-center p-t-72 medium", "list":"list-style-none p-l-16 p-r-16 p-t-24 m-auto max-w-680 lg:p-t-72\n"})];
module.exports = doc.length <= 1 ? doc[0] : doc;